import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=46a545e2&scoped=true"
import script from "./MyRequests.vue?vue&type=script&lang=ts"
export * from "./MyRequests.vue?vue&type=script&lang=ts"
import style0 from "./MyRequests.vue?vue&type=style&index=0&id=46a545e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a545e2",
  null
  
)

export default component.exports